<template>
  <b-container id="org-chart-filter" fluid>
    <b-row class="w-100">
      <b-col md="8">
        <div class="p-2">
          <strong>
            <slot name="title">Approved Applications by year</slot>
          </strong>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div class="org-chart">
          <app-chart
            :chart-data="displayStats"
            :options="options"
            ref="chartFilter"
          ></app-chart>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Bar from "@/components/charts/Bar";
import * as _ from "lodash";
import randomColor from "randomcolor";
export default {
  props: ["stats"],
  data() {
    return {
      hoverElement: null
    };
  },
  computed: {
    numYears() {
      return this.labels.length;
    },
    options() {
      let _vm = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 50,
        onHover: function(e, elements) {
          if (elements.length) {
            elements[0]._chart.canvas.style.cursor = "pointer";
            _vm.hoverElement = elements[0];
            this.update();
            _vm.hoverElement._model.outerRadius += 5;
          } else {
            e.currentTarget.style.cursor = "default";
            if (_vm.hoverElement) {
              this.update();
              _vm.hoverElement = null;
            }
          }
        },
        layout: {
          padding: 7
        },
        tooltips: {
          titleFontSize: 20,
          xPadding: 10,
          yPadding: 10
        },
        legend: {
          display: false
        },
        borderAlign: "inner"
      };
    },
    numOrgs() {
      return this.labels.length;
    },
    labels() {
      return _.keys(this.stats);
    },
    colors() {
      let numOrgs = this.labels.length;
      return randomColor({
        count: numOrgs,
        hue: "teal"
      });
    },
    legend() {
      let legends = [];
      for (let i = 0; i < this.labels.length; i++) {
        let label = this.labels[i];
        let color = this.colors[i];
        let val = this.stats[label];
        legends.push({ name: label, color: color, val: val });
      }
      return legends;
    },
    displayStats() {
      let labels = _.keys(this.stats);
      let data = _.map(this.stats, org => {
        return org;
      });

      return {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: '#0ED029', // approved
            data: data
          }
        ]
      };
    }
  },
  components: {
    appChart: Bar
  }
};
</script>
<style scoped>
#org-chart-filter {
  padding: 0.5em;
  border: 1px solid lightgrey;
  border-radius: 4px;
  width: 100%;
}
#org-chart-filter:hover {
  cursor: pointer;
}
.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

.text-center {
  text-align: center;
}
.clear-selection {
  color: #dc3545;
  cursor: pointer;
}
</style>
